import { create } from 'zustand';

export const useAssetGroupMeasureApplicabilityStore = create((set) => ({
    items: [],
    loading: false,
    error: null,
    searchParams: {
        page: 1,
        pageSize: 20,
        sortBy: 'assetGroupName',
        sortOrder: 'asc',
        search: '',
    },
    paginationData: {
        total: 0,
        totalPages: 0,
        page: 1,
        pageSize: 20,
    },
    updateDialogOpen: false,
    dialogRow: null,
    detail: null,
    detailLoading: false,
    linkedMeasureItems: [],
    linkedMeasureLoading: false,
    linkedMeasureSearchParams: {
        page: 1,
        pageSize: 10,
        sortBy: 'measure_code',
        sortOrder: 'asc',
        search: '',
    },
    linkedMeasurePagination: {
        total: 0,
        totalPages: 0,
        page: 1,
        pageSize: 10,
    },

    setItems: (items) => set({ items }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setSearchParams: (params) => set((state) => ({
        searchParams: { ...state.searchParams, ...params },
    })),
    setPaginationData: (paginationData) => set({ paginationData }),
    updateItemInList: (item) => set((state) => ({
        items: state.items.map((row) => (row.id === item.id ? item : row)),
    })),
    openUpdateDialog: (row) => set({ updateDialogOpen: true, dialogRow: row }),
    closeUpdateDialog: () => set({ updateDialogOpen: false, dialogRow: null }),
    setDetail: (detail) => set({ detail }),
    setDetailLoading: (detailLoading) => set({ detailLoading }),
    clearDetail: () => set({ detail: null }),
    setLinkedMeasureItems: (linkedMeasureItems) => set({ linkedMeasureItems }),
    setLinkedMeasureLoading: (linkedMeasureLoading) => set({ linkedMeasureLoading }),
    setLinkedMeasureSearchParams: (params) => set((state) => ({
        linkedMeasureSearchParams: { ...state.linkedMeasureSearchParams, ...params },
    })),
    setLinkedMeasurePagination: (linkedMeasurePagination) => set({ linkedMeasurePagination }),
    resetLinkedMeasureState: () => set({
        linkedMeasureItems: [],
        linkedMeasureLoading: false,
        linkedMeasureSearchParams: {
            page: 1,
            pageSize: 10,
            sortBy: 'measure_code',
            sortOrder: 'asc',
            search: '',
        },
        linkedMeasurePagination: {
            total: 0,
            totalPages: 0,
            page: 1,
            pageSize: 10,
        },
    }),
}));
